<template>
    <div>
      <secondHeader />
      <div class="clock-main">
        <sidebar />
        <main class="clock-content">
          <!-- Hero Section -->
          <section class="clock-hero">
            <div class="clock-hero-content">
              <h1 class="clock-hero-title">配信画面用デジタル時計</h1>
            </div>
          </section>

          <!-- Clock Grid Section -->
          <section class="clock-grid-section">
            <div class="clock-container">
              <div class="clock-grid">
                <div v-for="clock in allClocks" :key="clock.id" @click="openModal(clock.component)" class="clock-card">
                  <div v-if="clock.isPremium" class="clock-premium-badge">Premium</div>
                  
                  <div class="clock-preview-area" :class="{ 'neon-background': clock.id === 7 }">
                    <!-- バー時計専用テンプレート -->
                    <div v-if="clock.type === 'live' && clock.id === 6" :class="clock.previewClass" class="clock-live-preview">
                      <span class="bar-clock-time">{{ clock.timeFormat }}<span class="bar-clock-ampm">am</span></span>
                    </div>
                    
                    <!-- ネオン時計専用テンプレート -->
                    <div v-else-if="clock.type === 'live' && clock.id === 7" :class="clock.previewClass" class="clock-live-preview">
                      <span class="neon-time-preview">{{ clock.timeFormat }}<span class="neon-ampm-preview">{{ clock.ampmText }}</span></span>
                    </div>
                    
                    <!-- NYAN時計専用テンプレート -->
                    <div v-else-if="clock.type === 'live' && clock.id === 8" :class="clock.previewClass" class="clock-live-preview">
                      <div class="nyan-preview-content">
                        <span class="nyan-date-preview">{{ clock.dateFormat }}<span class="nyan-youbi-preview">{{ clock.dayOfWeek }}</span></span>
                        <span class="nyan-time-preview">{{ clock.timeFormat }}</span>
                        <div class="nyan-icon-area-preview">
                          <div class="nyan-icon-1-preview"></div>
                          <div class="nyan-icon-2-preview"></div>
                          <div class="nyan-icon-3-preview"></div>
                          <img src="@/assets/image/nya.svg" alt="肉球" width="20" height="20">
                          <div class="nyan-icon-3-preview"></div>
                          <div class="nyan-icon-2-preview"></div>
                          <div class="nyan-icon-1-preview"></div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- その他のライブ時計共通テンプレート -->
                    <div v-else-if="clock.type === 'live'" :class="clock.previewClass" class="clock-live-preview">
                      <span v-if="clock.dateFormat" :class="clock.dateClass">{{ clock.dateFormat }}</span>
                      <span :class="clock.timeClass">
                        <p v-if="clock.ampmPosition === 'before'" :class="clock.ampmClass">am</p>
                        {{ clock.timeFormat }}
                        <span v-if="clock.ampmPosition === 'after'" :class="clock.ampmClass">am</span>
                      </span>
                    </div>
                    
                    <!-- 画像プレビュー -->
                    <div v-else class="clock-image-preview">
                      <img :src="clock.imageSrc" :alt="clock.name" class="clock-preview-img">
                    </div>
                  </div>
                  
                  <div class="clock-card-content">
                    <h3 class="clock-card-title">{{ clock.name }}</h3>
                    <div class="clock-tags">
                      <span v-for="tag in clock.tags" :key="tag" class="clock-tag">{{ tag }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- モーダルの表示 -->
          <div v-if="showModal" class="modal" @click="closeModal">
            <div class="modal-content" @click.stop>
              <span class="close" @click="closeModal">&times;</span>
              <component :is="currentComponent" />
            </div>
          </div>

          <!-- Ad Section -->
          <section class="clock-ad-block">
            <div class="clock-container">
              <div class="clock-ad">
                <InFeedAdsense
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-9016794589237931"
                    data-ad-slot="4898735474">
                </InFeedAdsense>
              </div>
            </div>
          </section>

          <!-- Blog Section -->
          <section class="clock-blog-area">
            <div class="clock-blog-content">
              <h2 class="clock-blog-title">使い方はブログでチェック！</h2>
              <div class="clock-blog-row">
                <div class="clock-blog-thumb">
                  <img src="@/assets/article/thombnail-clock.png" alt="時計の使い方ガイド">
                </div>
                <div>
                  <p class="clock-blog-desc">具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                  <div class="clock-blog-btn">
                    <a href="https://www.ruri.info/obs-clock/" target="_blank" rel="noopener noreferrer" class="clock-check-btn">記事をチェック</a>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>
      </div>
    </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
import noticeBar from "../components/notice-bar.vue"
import clockapp from "../components/clock/clockapp.vue"
import simpleClockapp from "../components/clock/simpleClockapp.vue"
import noBgClock from "../components/clock/noBgClockapp.vue"
import shortClock from "../components/clock/shortClock.vue"
import bubbleClock from "../components/clock/randomBubbleClock.vue"
import barClock from "../components/clock/barClock.vue"
import neonClock from "../components/clock/neonClock.vue"
import nyanClock from "../components/clock/nyanClock.vue"
import premiumBarClock from "../components/clock/premiumBarClock.vue"

export default{
    components:{
        secondHeader,
        sidebar,
        noticeBar,
        clockapp,
        simpleClockapp,
        noBgClock,
        shortClock,
        bubbleClock,
        barClock,
        neonClock,
        nyanClock,
        premiumBarClock,
    },
    data(){
      return{
        isProduction: process.env.NODE_ENV === "production",
        showModal: false,
        currentComponent: null,
        allClocks: [
          {
            id: 1,
            name: 'グラデーション時計',
            component: 'clockapp',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', 'グラデ変更', 'フォント変更', 'アニメーション'],
            previewClass: 'clock-design-grad',
            dateClass: 'clock-date',
            timeClass: 'clock-time',
            dateFormat: '2022-09-29 THU',
            timeFormat: '04:12'
          },
          {
            id: 2,
            name: 'カラー時計',
            component: 'simpleClockapp',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', '色変更', 'フォント変更', 'シンプル'],
            previewClass: 'clock-design-simple',
            dateClass: 'clock-date',
            timeClass: 'clock-time',
            dateFormat: '2022-09-29 THU',
            timeFormat: '04:12'
          },
          {
            id: 3,
            name: 'シンプル時計',
            component: 'noBgClock',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', 'フォント変更', '背景なし', 'ミニマル'],
            previewClass: 'clock-design-nobg',
            dateClass: 'clock-date',
            timeClass: 'clock-time',
            dateFormat: '2022-09-29 THU',
            timeFormat: '04:12'
          },
          {
            id: 4,
            name: 'コンパクト時計',
            component: 'shortClock',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', 'フォント変更', '省スペース'],
            previewClass: 'clock-design-short',
            dateClass: 'short-clock-date',
            timeClass: 'short-clock-time',
            dateFormat: '09/29 THU',
            timeFormat: '04:12'
          },
          {
            id: 5,
            name: 'バブル時計',
            component: 'bubbleClock',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', 'グラデ変更', 'アニメーション'],
            previewClass: 'clock-design-bubble',
            timeClass: 'bubble-clock-time',
            ampmClass: 'bubble-clock-ampm',
            ampmPosition: 'before',
            timeFormat: '04:12'
          },
          {
            id: 6,
            name: 'バー時計',
            component: 'barClock',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', 'グラデ変更', '形状変更'],
            previewClass: 'clock-design-bar',
            timeFormat: '04:12'
          },
          {
            id: 7,
            name: 'ネオン時計',
            component: 'neonClock',
            type: 'live',
            isPremium: false,
            tags: ['日付切替', '色変更', '形状変更'],
            previewClass: 'clock-design-neon',
            timeFormat: '04:12',
            ampmText: 'am'
          },
          {
            id: 8,
            name: 'NYAN',
            component: 'nyanClock',
            type: 'live',
            isPremium: false,
            tags: ['カワイイ'],
            previewClass: 'clock-design-nyan',
            dateFormat: '09 / 29',
            dayOfWeek: 'THU.',
            timeFormat: '04:12'
          },
          {
            id: 9,
            name: 'タイムゾーン対応グラデ時計',
            component: 'premiumBarClock',
            type: 'image',
            isPremium: true,
            tags: ['タイムゾーン', 'グラデーション', '多機能'],
            imageSrc: require('@/assets/thumbnail/premium-grad-clock.png')
          }
        ]
      }
    },
    methods: {
      openModal(componentName) {
        this.currentComponent = componentName;
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
      }
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

/* Reset & Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Layout */
.clock-main {
  min-height: 100vh;
  display: flex;
}

.clock-content {
  flex: 1;
  background: #fafafa;
  padding: 0 16px;
  overflow-x: hidden;
}

/* Container */
.clock-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Hero Section */
.clock-hero {
  background: white;
  padding: 48px 0;
}

.clock-hero-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
}

.clock-hero-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
}

/* Clock Grid Section */
.clock-grid-section {
  background: white;
  padding: 32px 0;
}

.clock-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.clock-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
  overflow: hidden;
}

.clock-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.clock-premium-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  z-index: 2;
}

.clock-preview-area {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
}

.clock-live-preview {
  text-align: center;
  width: fit-content;
  margin: 0 auto;
  line-height: 1;
  border-radius: 8px;
  color: #fff;
  white-space: nowrap;
}

.clock-image-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clock-preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.clock-card-content {
  text-align: left;
}

.clock-card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
  line-height: 1.4;
}

.clock-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.clock-tag {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 4px 8px;
  border-radius: 6px;
  letter-spacing: 0.25px;
}

/* Clock Design Classes */
.clock-design-grad {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
  padding: 8px 16px;
}

.clock-design-simple {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background-color: #EF84EC;
  padding: 8px 16px;
}

.clock-design-nobg {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: transparent;
}

.clock-design-short {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: transparent;
}

.clock-design-nobg .clock-time, 
.clock-design-nobg .clock-date {
  color: #3064BA;
}

.clock-design-short .short-clock-time, 
.clock-design-short .short-clock-date {
  color: #3064BA;
}

.clock-design-bubble {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
  width: 150px;
  aspect-ratio: 22 / 18;
  border-radius: 80% 30% 50% 50%/50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* バー時計 - 詳細度を上げて.clock-live-previewを確実に上書き */
.clock-live-preview.clock-design-bar {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  background: linear-gradient(256deg, #0093E9 0%, #a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
  width: 220px;
  height: 70px;
  padding: 14px 42px 0px 42px;
  margin: 12px;
  border-radius: 100vh;
  color: #fff;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  line-height: initial;
}

/* Clock Text Styles */
.clock-time {
  letter-spacing: 0.05em;
  font-size: 48px;
  display: block;
}

.short-clock-time {
  letter-spacing: 0em;
  font-size: 48px;
  display: block;
}

.clock-date {
  padding-top: 8px;
  letter-spacing: 0.1em;
  font-size: 16px;
  display: block;
}

.short-clock-date {
  padding-top: 8px;
  letter-spacing: 0.1em;
  font-size: 16px;
  display: block;
}

.bubble-clock-time {
  letter-spacing: 0.05em;
  font-size: 36px;
  line-height: 0.75em;
  margin-bottom: 6px;
}

.bubble-clock-ampm {
  font-size: 0.5em;
  margin-right: 0;
  display: flex;
  justify-content: flex-end;
}

/* バー時計のテキストスタイル - 詳細度を上げて確実に適用 */
.clock-live-preview.clock-design-bar .bar-clock-time {
  letter-spacing: 0.05em;
  font-size: 38px;
  line-height: 0.75em !important;  /* clock-live-previewのline-height: 1を強制上書き */
  margin-bottom: 10px;
}

.clock-live-preview.clock-design-bar .bar-clock-ampm {
  font-size: 0.7em;
  vertical-align: 2px;
  margin-left: 5px;
}

/* NYAN時計のスタイル */
.clock-design-nyan {
  font-family: "Maven Pro", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  width: 200px;
  height: 125px;
  padding-top: 12px;
  display: flex;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background-color: #FFF9F1;
  border-radius: 0 0 10px 10px;
  border-right: 3px solid #8E3605;
  border-bottom: 3px solid #8E3605;
  border-left: 3px solid #8E3605;
  border-top: none;
  color: #8E3605;
}

.nyan-preview-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.nyan-date-preview {
  letter-spacing: 0.1em;
  font-size: 12px;
  margin-bottom: 8px;
  display: block;
  text-align: center;
  font-weight: bold;
}

.nyan-youbi-preview {
  font-size: 12px;
  margin-left: 6px;
}

.nyan-time-preview {
  letter-spacing: 0.06em;
  font-size: 42px;
  line-height: 0.75em;
  margin-bottom: 8px;
}

.nyan-icon-area-preview {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 6px auto;
  padding: 0 30px;
  box-sizing: border-box;
}

.nyan-icon-1-preview {
  width: 5px;
  height: 5px;
  background-color: #FDA43C;
  border-radius: 50%;
}

.nyan-icon-2-preview {
  width: 5px;
  height: 5px;
  background-color: #E8B6FF;
  border-radius: 50%;
}

.nyan-icon-3-preview {
  width: 5px;
  height: 5px;
  background-color: #3ADED4;
  border-radius: 50%;
}

/* ネオン時計のスタイル */
.clock-design-neon {
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  width: 220px;
  height: 70px;
  padding: 14px 42px 0px 42px;
  margin: 12px;
  color: #0ff;
  background-color: transparent;
  border: 2px solid #0ff;
  border-radius: 100vh;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  text-shadow: 0 0 3px #0ff, 0 0 6px #0ff, 0 0 3px #0ff, 0 0 6px #0ff;
  box-shadow: 0 0 3px #0ff, 0 0 6px #0ff, inset 0 0 3px #0ff, inset 0 0 6px #0ff;
}

.neon-time-preview {
  letter-spacing: 0.05em;
  font-size: 42px;
  line-height: 0.75em;
  margin-bottom: 8px;
}

.neon-ampm-preview {
  font-size: 0.7em;
  vertical-align: 2px;
  margin-left: 4px;
}

/* ネオン時計専用の黒背景 */
.clock-preview-area.neon-background {
  background: #1a1a1a;
  border-radius: 12px;
}

/* Animations */
@keyframes sky-gradient-animation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes green-gradient-animation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
/* Modal */
.modal {
  display: block;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: left;
}

.modal-content {
  background-color: #fefefe;
  margin: 2vh auto;
  padding: 32px;
  border: none;
  border-radius: 16px;
  width: 90%;
  max-width: 1000px;
  min-height: 85vh;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

.close {
  color: #64748b;
  float: right;
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
  transition: color 0.2s ease;
}

.close:hover,
.close:focus {
  color: #0f172a;
  text-decoration: none;
  cursor: pointer;
}

/* Ad Section */
.clock-ad-block {
  background: #f8fafc;
  padding: 48px 0;
  text-align: center;
}

.clock-ad {
  max-width: 70%;
  margin: 0 auto;
  display: block;
}

/* Blog Area */
.clock-blog-area {
  background: white;
  padding: 48px 0;
  border-top: 1px solid #e2e8f0;
}

.clock-blog-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 24px;
}

.clock-blog-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #0f172a;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: -0.025em;
}

.clock-blog-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
}

.clock-blog-thumb img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.clock-blog-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #64748b;
  margin-bottom: 24px;
}

.clock-blog-btn .clock-check-btn {
  display: inline-block;
  background: #0f172a;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.clock-blog-btn .clock-check-btn:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 1024px) {
  .clock-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .clock-container {
    padding: 0 20px;
  }
}

@media (max-width: 768px) {
  .clock-hero {
    padding: 32px 0;
  }
  
  .clock-hero-title {
    font-size: 1.875rem;
  }
  
  .clock-grid-section {
    padding: 48px 0;
  }
  
  .clock-grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }
  
  .clock-card {
    padding: 16px;
  }
  
  .clock-preview-area {
    height: 160px;
    margin-bottom: 12px;
  }
  
  .clock-time {
    font-size: 40px;
  }
  
  .short-clock-time {
    font-size: 40px;
  }
  
  .bubble-clock-time {
    font-size: 30px;
  }
  
  .clock-design-bubble {
    width: 130px;
  }
  
  /* Proportional scaling for bar clock */
  .clock-live-preview.clock-design-bar {
    transform: scale(0.7);
    margin: 0;
  }
  
  .clock-container {
    padding: 0 16px;
  }
  
  .clock-content {
    padding: 0 8px;
  }
  
  .clock-blog-row {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .modal-content {
    width: 95%;
    padding: 24px;
    margin: 5vh auto;
  }
}

@media (max-width: 480px) {
  .clock-hero-title {
    font-size: 1.5rem;
  }
  
  .clock-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .clock-preview-area {
    height: 140px;
  }
  
  .clock-container {
    padding: 0 12px;
  }
  
  .clock-content {
    padding: 0 4px;
  }
  
  .clock-card-title {
    font-size: 1rem;
  }
  
  .clock-time {
    font-size: 32px;
  }
  
  .short-clock-time {
    font-size: 32px;
  }
  
  .clock-date {
    font-size: 12px;
  }
  
  .short-clock-date {
    font-size: 12px;
  }
  
  .bubble-clock-time {
    font-size: 24px;
  }
  
  .clock-design-bubble {
    width: 110px;
  }

  /* Proportional scaling for bar clock */
  .clock-live-preview.clock-design-bar {
    transform: scale(0.6);
    margin: 0;
  }
  
  .modal-content {
    width: 98%;
    padding: 16px;
    margin: 2vh auto;
    min-height: 90vh;
  }
}


</style>
